import Section from '../components/Section';

export default function Sobre() {
  return (
    <main>
      <Section title="Sobre Nós">
        Fundada com o propósito de inovar no setor de biocombustíveis, a Usina Rosa atua com foco em qualidade, responsabilidade ambiental e social.
      </Section>
    </main>
  );
}
